// DayLabel.tsx

import React from "react";
import styled from "styled-components";

interface DayLabelProps {
  label: string;
}

const DayLabelWrapper = styled.div`
  color: #86888b;
  text-align: center;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const DayLabel: React.FC<DayLabelProps> = ({ label }) => {
  return <DayLabelWrapper>{label}</DayLabelWrapper>;
};

export default DayLabel;
